/* eslint-disable @typescript-eslint/naming-convention */
// referenced at https://docs.google.com/document/d/1t9bxj8KdNFcqncl_pdu-DhECJOvI0yv74oRJm0SIwuk/edit
const enumFactory = (enumObj, keyType = 'number') => {
    const inverse = {};
    Object.keys(enumObj).forEach((key) => {
        const values = enumObj[key];
        if (typeof values === 'string') {
            inverse[values] = key;
        }
        else {
            values.forEach((value) => {
                inverse[value] = key;
            });
        }
    });
    const obj = Object.assign(Object.assign({}, enumObj), inverse);
    return Object.assign(Object.assign({}, obj), { toArray: () => Object.keys(enumObj).map((key) => ({ key: keyType === 'number' ? parseInt(key) : key, value: enumObj[key] })), toIdNameArray: () => Object.keys(enumObj).map((key) => ({ id: keyType === 'number' ? parseInt(key) : key, name: enumObj[key] })), toIdNameArrayString: () => Object.keys(enumObj).map((key) => ({ id: key, name: enumObj[key] })), get: (key) => obj[key] });
};
const services = enumFactory({
    1: 'Admin Portal', // (contains TruRisk Admin users)
    2: 'Risk Engineer Portal',
    // 4: 'Risk Manager Portal',
    8: 'Specialty Portal',
    16: 'Broker Portal',
    32: 'SME Portal',
    64: 'Insurer Portal',
});
const serviceLinks = enumFactory({
    0: '/',
    1: '/admin',
    2: '/engineer',
    4: '/manager',
    8: '/specialty',
    16: '/broker',
    32: '/client',
    64: '/insurer',
});
const serviceLinksLocal = enumFactory({
    0: 'http://localhost:4000/',
    1: 'http://localhost:4001/admin',
    2: 'http://localhost:4002/engineer',
    4: 'http://localhost:4004/manager',
    8: 'http://localhost:4008/specialty',
    16: 'http://localhost:4016/broker',
    32: 'http://localhost:4032/client',
    64: 'http://localhost:4064/insurer',
});
const issue_types = enumFactory({
    1: 'Observation',
    2: 'Task',
    4: 'Incident',
    8: 'Near Miss',
});
const issue_statuses = enumFactory({
    1: 'New',
    2: 'In Progress',
    4: 'Resolved',
    8: 'Closed',
    16: 'Rejected',
});
const near_miss_categories = enumFactory({
    1: 'Equipment maintenance',
    2: 'Narrow escape',
    4: 'Potential fall from height',
    8: 'Risky behaviour',
    16: 'Slips and trips',
    32: 'Unmarked Hazard',
    64: 'Unsafe equipment operation',
    124: 'Working at heights',
});
const roles = enumFactory({
    // role_id
    1: 'sadmin', // ???
});
const usage_type = enumFactory({
    // media
    1: 'Platform assets such as logos, etc',
    2: 'Content assets such as images referenced in response',
    3: 'Documents upload to the platform by Risk Engineer or a Client',
    4: 'Platform user avatar',
});
const location_type = enumFactory({
    1: 'Headquarters',
    2: 'Survey',
    3: 'Inspection',
});
const survey_status = enumFactory({
    1: 'Planning',
    2: 'Visit scheduled',
    3: 'Visit completed',
    4: 'Report issued',
});
const calculated_status = enumFactory({
    1: 'To Do',
    2: 'In progress',
    4: 'Done',
    8: 'Done late',
    16: 'Missed',
    32: 'Overdue',
    64: 'Pending Approval',
});
const program_status = enumFactory({
    1: 'Draft',
    2: 'Active',
    4: 'Archived',
});
const document_type = enumFactory({
    1: 'Survey Report',
    2: 'Agenda',
    3: 'Client Document',
    4: 'Policy Document',
    5: 'Private Document',
    7: 'Claim Document',
});
const cognito_status = enumFactory({
    UNCONFIRMED: 'UNCONFIRMED',
    CONFIRMED: 'CONFIRMED',
    ARCHIVED: 'ARCHIVED',
    COMPROMISED: 'COMPROMISED',
    UNKNOWN: 'UNKNOWN',
    RESET_REQUIRED: 'RESET REQUIRED',
    FORCE_CHANGE_PASSWORD: 'FORCE CHANGE PASSWORD',
}, 'string');
const risk_category_letters = enumFactory({
    A: 'Not Significant',
    B: 'Minor',
    C: 'Moderate',
    D: 'Major',
    E: 'Severe',
}, 'string');
const risk_category_numbers = enumFactory({
    '1': 'Impractical',
    '2': 'Not Likely',
    '3': 'Possible',
    '4': 'Likely',
    '5': 'Certain',
}, 'string');
const risk_category_levels = enumFactory({
    '1': 'Low',
    '2': 'Medium',
    '3': 'Higher - Medium',
    '4': 'Higher',
}, 'string');
const category_level = {
    A5: 3,
    B5: 3,
    C5: 3,
    D5: 4,
    E5: 4,
    A4: 2,
    B4: 2,
    C4: 3,
    D4: 3,
    E4: 4,
    A3: 1,
    B3: 1,
    C3: 2,
    D3: 3,
    E3: 4,
    A2: 1,
    B2: 1,
    C2: 2,
    D2: 2,
    E2: 3,
    A1: 1,
    B1: 1,
    C1: 2,
    D1: 2,
    E1: 3,
};
const recommendation_criticality = enumFactory({
    1: 'Advisory (P3)',
    2: 'Significant (P2)',
    4: 'Critical (P1)',
});
const recommendation_status = enumFactory({
    1: 'New',
    32: 'In Progress',
    4: 'Under Review',
    16: 'No Progress',
    64: 'Pending Verification',
    128: 'Completed',
    8: 'Declined',
    2: 'Superseded',
});
const manager_recommendation_status = enumFactory({
    4: 'Under Review',
    8: 'Declined',
    32: 'In Progress',
    64: 'Completed',
});
const contact_type = enumFactory({
    1: 'Client',
    2: 'Location',
    4: 'Survey',
    8: 'Recommendation',
    16: 'Impairment',
});
const policy_type = enumFactory({
    1: 'Property Damage',
    2: 'Business Interruption',
    4: 'Casualty - General Liability',
    8: 'Casualty - Excess Liability',
    16: 'Construction - All Risk',
    32: 'Construction - Delay in Startup',
    64: 'Product Recall',
});
const media_type = enumFactory({
    // media
    0: 'Undefined',
    1: 'Image',
    2: 'Video',
    3: 'Audio',
    4: 'Document',
    5: 'Map',
});
const supportedMimeTypes = {
    image: ['image/jpeg', 'image/gif', 'image/png', '1', 'image', 'image-document'],
    audio: ['audio/mp3', 'audio/m4a', 'audio/x-m4a', 'audio/aac'],
    document: [
        'text/csv',
        'text/plain',
        'application/msword',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        '4',
        '5',
        'embed',
        'embed-document',
    ],
    video: ['video/mp4', 'video/quicktime', 'video', '2', 'video', 'video-document'],
};
function getMediaType(mime) {
    if (supportedMimeTypes.image.includes(mime)) {
        return media_type.Image;
    }
    if (supportedMimeTypes.audio.includes(mime)) {
        return media_type.Audio;
    }
    if (supportedMimeTypes.video.includes(mime)) {
        return media_type.Video;
    }
    if (supportedMimeTypes.document.includes(mime)) {
        return media_type.Document;
    }
    return media_type.Undefined;
}
const doc_types = enumFactory({
    'image/jpeg': 'IMG',
    'image/gif': 'IMG',
    'image/png': 'IMG',
    'audio/mp3': 'MISC',
    'audio/m4a': 'MISC',
    'audio/x-m4a': 'MISC',
    'audio/aac': 'MISC',
    'text/csv': 'CSV',
    'text/plain': 'DOC',
    'application/msword': 'DOC',
    'application/pdf': 'PDF',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOC',
    'application/vnd.ms-excel': 'XLS',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLS',
    'application/vnd.ms-powerpoint': 'PPT',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPT',
    'video/mp4': 'VID',
});
const impairment_type = enumFactory({
    1: 'Planned',
    2: 'Emergency',
});
const impairment_status = enumFactory({
    1: 'Impaired',
    2: 'Restored',
});
const interval = enumFactory({
    1: 'Hour(s)',
    2: 'Day(s)',
    4: 'Week(s)',
    8: 'Month(s)',
    16: 'Quarter(s)',
    64: 'Year(s)',
});
const control_interval = enumFactory({
    2: 'Day(s)',
    4: 'Week(s)',
    8: 'Month(s)',
    16: 'Quarter(s)',
    64: 'Year(s)',
});
const smallerInterval = enumFactory({
    128: 'Minute(s)',
    1: 'Hour(s)',
    2: 'Day(s)',
    4: 'Week(s)',
    8: 'Month(s)',
    16: 'Quarter(s)',
    64: 'Year(s)',
    256: 'Week-end(s)',
    512: 'Month-end(s)',
    1024: 'Year-end(s)',
});
const assignment_types = enumFactory({
    1: 'Manager',
    2: 'User',
    4: 'Company',
});
const activity_sources = enumFactory({
    1: 'TruRisk',
    2: 'Custom',
    4: 'Public',
});
const activity_sources_public = enumFactory({
    2: 'Custom',
    4: 'Public',
});
const trigger_type_manager = enumFactory({
    1: 'Automatic',
    4: 'User Activated',
    32: 'Manual',
    64: 'Weather',
});
const trigger_type_user = enumFactory({
    2: 'User-Defined Date',
    4: 'User Activated',
    8: 'Activity Completed',
    16: 'Activity Step Option',
    32: 'Manual',
    128: 'Activity Missed',
});
const trigger_type_company = enumFactory({
    1: 'Automatic',
    2: 'User-Defined Date',
    16: 'Activity Step Option',
    32: 'Manual',
});
const priority_types = enumFactory({
    1: 'Low',
    2: 'Medium',
    4: 'High',
});
const company_status = enumFactory({
    1: 'Pending policy upload',
    2: 'Pending policy review',
    4: 'Flagged',
    8: 'Active',
    3: 'Policy Lapsed',
});
const section_type = enumFactory({
    1: 'Questionnaire',
    // 2: 'Task', // temporary disabled
    4: 'Quiz',
    // 8: 'Information', // temporary disabled
    16: 'Scrollable',
});
const public_section_type = enumFactory({
    1: 'Questionnaire',
    // 2: 'Task', // temporary disabled
    4: 'Quiz',
    // 8: 'Information', // temporary disabled
    // 16: 'Scrollable',
});
const step_type = enumFactory({
    1: 'Text',
    2: 'Number',
    // 4: 'Binary (Yes/No)', // temporary disabled
    8: 'Single choice',
    9: 'Multiple choice',
    16: 'Confirm / Complete',
    32: 'Media Upload',
    64: 'Rating',
    // 128: 'Signature',
    256: 'Date',
    512: 'Email',
    1024: 'File',
    2048: 'Risk Profile',
});
const public_step_type = enumFactory({
    1: 'Text',
    2: 'Number',
    // 4: 'Binary (Yes/No)', // temporary disabled
    8: 'Single choice',
    9: 'Multiple choice',
    16: 'Confirm / Complete',
    32: 'Media Upload',
    // 64: 'Rating',
    // 128: 'Signature',
    256: 'Date',
    // 512: 'Email',
    // 1024: 'File',
    // 2048: 'Risk Profile',
});
const risk_control_type = enumFactory({
    1: 'Static',
    2: 'Risk Object',
    4: 'Policy',
    8: 'Dynamic',
});
const dynamic_formula_type = enumFactory({
    1: 'Linear',
    2: 'Threshold',
    4: 'Frequency',
});
var enum_section_type;
(function (enum_section_type) {
    enum_section_type[enum_section_type["QUESTIONNAIRE"] = 1] = "QUESTIONNAIRE";
    enum_section_type[enum_section_type["TASK"] = 2] = "TASK";
    enum_section_type[enum_section_type["QUIZ"] = 4] = "QUIZ";
    enum_section_type[enum_section_type["INFORMATION"] = 8] = "INFORMATION";
    enum_section_type[enum_section_type["CHECKLIST"] = 16] = "CHECKLIST";
})(enum_section_type || (enum_section_type = {}));
var enum_step_type;
(function (enum_step_type) {
    enum_step_type[enum_step_type["TEXT"] = 1] = "TEXT";
    enum_step_type[enum_step_type["NUMBER"] = 2] = "NUMBER";
    enum_step_type[enum_step_type["BINARY"] = 4] = "BINARY";
    enum_step_type[enum_step_type["SINGLE"] = 8] = "SINGLE";
    enum_step_type[enum_step_type["MULTIPLE"] = 9] = "MULTIPLE";
    enum_step_type[enum_step_type["CONFIRM"] = 16] = "CONFIRM";
    enum_step_type[enum_step_type["MEDIA"] = 32] = "MEDIA";
    enum_step_type[enum_step_type["RATING"] = 64] = "RATING";
    enum_step_type[enum_step_type["DATE"] = 256] = "DATE";
    enum_step_type[enum_step_type["EMAIL"] = 512] = "EMAIL";
    enum_step_type[enum_step_type["FILE"] = 1024] = "FILE";
    enum_step_type[enum_step_type["RISKPROFILE"] = 2048] = "RISKPROFILE";
})(enum_step_type || (enum_step_type = {}));
const effort_type = enumFactory({
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
});
const rating_type = enumFactory({
    1: 'Star',
    // 2: 'Reaction', // temporary disabled
    // 4: 'Slider',
});
const section_trigger_type = enumFactory({
    // 1: 'All previous required steps are completed', // TRUR-500 Hide this label
    2: 'A specific option is selected in a previous step',
    4: 'The site’s risk profile is:',
});
const section_public_trigger_type = enumFactory({
    // 1: 'All previous required steps are completed', // TRUR-500 Hide this label
    2: 'A specific option is selected in a previous step',
});
export { enumFactory, services, serviceLinks, serviceLinksLocal, roles, usage_type, location_type, step_type, enum_section_type, enum_step_type, section_type, survey_status, document_type, recommendation_criticality, recommendation_status, manager_recommendation_status, contact_type, media_type, supportedMimeTypes, getMediaType, cognito_status, risk_category_letters, risk_category_numbers, risk_category_levels, category_level, policy_type, impairment_type, impairment_status, interval, control_interval, smallerInterval, trigger_type_company, trigger_type_user, trigger_type_manager, doc_types, assignment_types, program_status, priority_types, company_status, calculated_status, activity_sources, issue_types, issue_statuses, risk_control_type, dynamic_formula_type, public_step_type, effort_type, rating_type, section_trigger_type, section_public_trigger_type, public_section_type, activity_sources_public, near_miss_categories, };
